<template>
  <div class="main-wrapper" ref="wrapper">
    <!-- LABEL BOX -->
    <!-- STAGE -->
    <div class="image-container" ref="container">
      <transition name="fade" mode="out-in">
        <div
          class="labelbox"
          v-if="highlightedId !== ''"
          @click="highlightedId = ''"
            
        > 
          <transition name="fade" mode="out-in">
            <p :key="highlightedId" >{{ highLightLabel }}</p>
          </transition>
        </div>
      </transition>
      <img @load="imageLoaded" class="image" :src="imagePath" />
      <div class="circle-container">
        <svg
          width="100%"
          height="100%"
          @mousedown="mouseDown"
          @mousemove="mouseMove"
          @mouseup="mouseUp"
          @touchstart="touchStart"
          @touchmove="touchMove"
          @touchend="touchEnd"
        >
          <g v-for="item in imageData" :key="item.id">
            <title>{{ item.value }}</title>
            <circle
              :cx="item.rawData ? item.rawData.x * scaleX : 0"
              :cy="item.rawData ? item.rawData.y * scaleY : 0"
              r="10"
              class="circle"
              :data-id="item.id"
              stroke="black"
              stroke-width=" 1"
              fill="white"
            ></circle>
            <text
              :x="item.rawData ? item.rawData.x * scaleX : 0"
              :y="item.rawData ? (item.rawData.y * scaleY) + addHeight() : 0"
              text-anchor="middle"
              class="circle-text-index"
              alignment-baseline="central"
              :data-id="item.id"
            >
              {{ item.index }}
            </text>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as types from "../store/types";

export default {
  name: "Stage",
  data() {
    return {
      highlightedId: "",
      saveTimeout: null,
      currentItem: null,
      scaleX: 400,
      scaleY: 400,
    };
  },
  computed: {
    ...mapState({
      imagePath: (state) => state.imagePath,
      imageData: (state) => state.imageData,
    }),
    highLightLabel() {
      return this.imageData.find((x) => x?.id === this.highlightedId)?.value;
    },
  },
  created() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.resizeHandler);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  methods: {
    addHeight() {
      return this.detectBrowser('Firefox') ? 4 : 0;
    },
    detectBrowser(name) {
      return navigator.userAgent.indexOf(name) !== -1;
    },
    mouseDown(event) {
      const dataId = event.target.getAttribute("data-id");
      if (dataId) {
        this.highlightedId = dataId == this.highlightedId? "" : dataId;
        this.currentItem = dataId;
      }else{
        this.highlightedId = "";
      }
    },
    mouseMove(event) {
      if (this.currentItem) {
        this.handleMouseMove(event);
      }
    },
    mouseUp() {
      this.currentItem = null;
      clearTimeout(this.saveTimeout);
      this.saveTimeout = setTimeout(() => {
        this.saveChanges();
      }, 500);
    },
    handleMouseMove(event) {
      const selectedgroup = this.imageData.find(
        (x) => x.id === this.currentItem
      );
      if (selectedgroup && selectedgroup.rawData) {
        selectedgroup.rawData.x = event.offsetX / this.scaleX;
        selectedgroup.rawData.y = event.offsetY / this.scaleY;
      }
    },
    touchStart(event) {
      const id = event.target.getAttribute("data-id");
      if (id) {
        this.currentItem = id;
      }
    },
    touchMove(event) {
      if (!this.currentItem) return;
      const svg = event.target.closest("svg");
      const rect = svg.getBoundingClientRect();
      const touch = event.touches[0] || event.changedTouches[0];
      const x = touch.clientX - rect.left;
      const y = touch.clientY - rect.top;

      const selectedgroup = this.imageData.find(
        (x) => x.id === this.currentItem
      );

      if (selectedgroup && selectedgroup.rawData) {
        selectedgroup.rawData.x = x / this.scaleX;
        selectedgroup.rawData.y = y / this.scaleY;
      }
    },
    touchEnd() {
      this.currentItem = null;
      clearTimeout(this.saveTimeout);
      this.saveTimeout = setTimeout(() => {
        this.saveChanges();
      }, 500);
    },

    resizeHandler() {
      this.scaleX = this.$refs.container.clientWidth;
      this.scaleY = this.$refs.container.clientHeight;
    },

    async parseData() {
      this.createInitPosition();
    },
    async saveChanges() {
      const url = `${this.$baseUrl}`;
      const body = {
        id: this.$id,
        imagePath: this.imagePath,
        imageData: [...this.imageData],
      };
      try {
        const response = await fetch(url, {
          method: "PUT",
          body: JSON.stringify(body),
        });
        if (response.status === 200) return;
      } catch (error) {
        console.log(error);
      }
    },
    createInitPosition() {
      this.imageData.forEach((point) => {
        if (point.rawData !== null) return;
        else {
          this.$store.dispatch(types.UPDATE_IMAGEDATA, {
            id: point.id,
            rawData: {
              x: 0.005 * point.index + 0.02, //.064 0.022
              y: 0.02,
            },
          });
        }
      });
    },
    imageLoaded() {
      this.scaleX = this.$refs?.container?.clientWidth;
      this.scaleY = this.$refs?.container?.clientHeight;
      this.parseData();
    },
  },
  mounted() {
    if (this.$refs.container) {
      this.scaleX = this.$refs?.container?.clientWidth;
      this.scaleY = this.$refs?.container?.clientHeight;
    }
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  position: relative;
  width: 800px;
  .image {
    width: 100%;
  }
  .circle-container {
    position: absolute;
    width: 100%;
    height: 100%;
      touch-action: none;

    top: 0px;
    left: 0px;
      z-index: 100;

  }
}
.circle {
  touch-action: none;
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.circle-text-index {
  touch-action: none;
  font-size: 12px;
  text-anchor: middle;
  font-weight: lighter;
  stroke: black;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

.labelbox {
  position: absolute;
  user-select: none;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  width: 100%;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(2px);
  p{
    user-select: text;
    vertical-align: middle;
    margin: 5px 0;
  }
}

.main-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.fade-enter-active {
  transition: all 0.3s ease;
}
.fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
